<template>
  <div class="row">
    <div class="col-xl-12 order-xl-1">
      <card card-body-classes="table-full-width" no-footer-line>
        <div class="row adaptive-margin mx-3 justify-content-between mb-2">
          <div class="d-flex flex-column  justify-content-start">
            <h4 class="card-title" style="margin-top: 0!important;">{{ locale.workers }}</h4>
          </div>
          <div class="d-flex flex-column  justify-content-start" style="align-items: flex-end!important;">
            <div v-if="for_which !== 'reports'"
            >
              <n-button
                  type="primary"
                  class="btn btn-sm btn-primary"
                  style="margin-top: 0!important"
                  @click.native="onAddUser()"
              >
                <span class="over400">{{locale.add_user}}</span>
                <span class="below400">+</span>
              </n-button>
            </div>
            <div v-if="for_which === 'reports'"
            >
              <n-button
                  type="secondary"
                  class="btn btn-sm btn-secondary"
                  style="margin-top: 0!important"
                  @click.native="printListWorkers()"
              >
                <span class="over400">{{locale.print}}</span>
                <i class="below400 el-icon-printer"></i>
              </n-button>
            </div>
          </div>
        </div>
        <div class=" text-center">
          <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-input v-model="searchedValue" @keyup.native="searchWorker()" placeholder="Search..."></el-input>
          </div>
          <br>
          <el-table stripe style="width: 100%" @current-change="selectWorkerReport" :data="usersFiltered">
            <el-table-column prop="employment_number"
                             v-bind:label="locale.employment_number"
                             sortable
                             :min-width="250"
            />
            <el-table-column prop="first_name"
                             v-bind:label="locale.first_name"
                             sortable
                             :sort-method="sortFName"
                             :min-width="250"
            />
            <el-table-column prop="last_name"
                             v-bind:label="locale.last_name"
                             sortable
                             :sort-method="sortLName"
                             :min-width="250"
            />
            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
            >
            </el-table-column>
            <el-table-column v-if="for_which !== 'reports'" :min-width="135" fixed="right" label="Actions">
              <div
                  slot-scope="{ row }"
                  class="table-actions"
                  style="margin-left: 10px"
              >

                <el-checkbox class="pr-2" @change.native="changeStatus(row.id, row.status)" title="Status" v-model="row.status" size="large" />

                <el-tooltip content="Edit" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onEditUser(row.id)"
                      type="info"
                      size="sm"
                      round
                      icon
                  >
                    <i class="now-ui-icons ui-2_settings-90"></i>
                  </n-button>
                </el-tooltip>

                <el-tooltip content="Delete" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onOpenCalendar(row.id)"
                      class="remove"
                      type="danger"
                      size="sm"
                      round
                      icon
                  >
                    <i class="fa fa-times"></i>
                  </n-button>
                </el-tooltip>
              </div>
            </el-table-column>

            <el-table-column v-if="for_which == 'reports'" :min-width="135" fixed="right" label="Actions">
              <div
                  slot-scope="{ row }"
                  class="table-actions"
                  style="margin-left: 10px"
              >
                <el-tooltip v-bind:content="locale.print" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onPrintSingleWorker($event, row.id)"
                      type="info"
                      size="sm"
                      round
                      icon
                  >
                    <i class="now-ui-icons files_paper"></i>
                  </n-button>
                </el-tooltip>
                <el-tooltip v-bind:content="locale.Calendar" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onOpenCalendar($event, row.id)"
                      type="warning"
                      size="sm"
                      round
                      icon
                  >
                    <i class="now-ui-icons tech_watch-time"></i>
                  </n-button>
                </el-tooltip>
                <el-tooltip v-bind:content="locale.Timesheet" :open-delay="300" placement="top">
                  <n-button
                      @click.native="onOpenTimesheet($event, row.id)"
                      type="success"
                      size="sm"
                      round
                      icon
                  >
                    <i class="now-ui-icons education_agenda-bookmark"></i>
                  </n-button>
                </el-tooltip>
              </div>
            </el-table-column>
          </el-table>
        </div>
        <modal name="user-form" :adaptive="true"
               height="auto" :scrollable="true">
          <div style="margin: 1em; margin-top: 3em;">
            <n-button
                @click.native="onModalHide('user-form')"
                class="remove text-end close-modal-btn"
                type="danger"
                size="sm"
                round
                icon
            >
              <i class="fa fa-times"></i>
            </n-button>
            <div class="d-flex flex-column">
              <div class="d-flex adaptive-row adaptive-justify-content">
                <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.client_project_number }}:* </span>
                  <the-mask mask="###" v-model="new_user_emp_num" @keyup.native="validateEmpNum()"/>
                </div>
                <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.Role }}:* </span>
                  <select v-model="selected_role">
                    <option v-for="role in roles" v-bind:key="role.name">{{role.name}}</option>
                  </select>
                </div>
              </div>
              <div class="d-flex adaptive-row adaptive-justify-content">
                <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.First_Name }}:* </span>
                  <input v-model="new_user_fn" >
                </div>
                <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.Second_Name }}:* </span>
                  <input v-model="new_user_ln">
                </div>
              </div>
              <div class="d-flex adaptive-row adaptive-justify-content">
                <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.login }}:* </span>
                  <input v-model="new_user_lg" @keyup="validateLogin()">
                </div>
                <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.password }}:* </span>
                  <input v-model="new_user_psw">
                </div>
              </div>
              <div class="d-flex adaptive-row adaptive-justify-content">
                <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.password_confirmation }}:* </span>
                  <input v-model="new_user_psw_cfm">
                </div>
                <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.personal_no }}:* </span>
                  <the-mask mask="######-####" v-model="new_user_pidn" @keyup.native="validatePidn()" placeholder="XXXXXX-XXXX" />
                </div>
              </div>
              <div class="d-flex adaptive-row adaptive-justify-content">
                <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.email }}:* </span>
                  <input type="email" v-model="new_user_email" @keyup="validateEmail()">
                </div>
                <div class="mb-3 d-flex flex-column adaptive-row-child-width">
                  <span class="w-100">{{ locale.phone }}:* </span>
                  <input v-model="new_user_phone">
                </div>
              </div>
              <div v-if="this.user_ag == null" class="adaptive-row adaptive-justify-content">
                <div class="d-flex flex-column adaptive-row-child-width">
                <span class="w-100">{{ locale.access_groups }}:* </span>
                <select v-model="selected_ag">
                  <option v-for="item in ag" v-bind:key="item.title">{{item.title}}</option>
                </select>
              </div>
                <div class=" d-flex flex-column adaptive-row-child-width" style="margin-bottom: 0!important;">
                </div>
              </div>
            </div>
            <hr>
            <div class="text-center"><b>Address</b></div>
            <div class="d-flex flex-column">
              <div class="d-flex adaptive-justify-content adaptive-margin">
                <div class="d-flex flex-column w-100">
                  <span class="w-100">{{ locale.coordinates }}:* </span>
                  <input readonly  style="height: 2rem"
                         :value="this.selected_latitude ? this.selected_latitude + ', ' + this.selected_longitude : ''">
                </div>
                <div class="d-flex mx-3 flex-column">
                  <n-button v-bind:class="map_visible ? 'hide-map' : 'show-map'"
                            style="height: 3rem; width: 1rem; background-color: white;"
                            @click.native="addressForm()"></n-button>
                </div>
              </div>
              <div class="d-flex adaptive-justify-content">
                <div class="mb-3 d-flex flex-column w-40">
                  <span class="w-100">{{ locale.postal_code }}:* </span>
                  <input class="w-100" style="height: 2rem" v-model="this.worker_selected_pc">
                </div>
                <div class="d-flex flex-column w-40">
                  <span class="w-100">{{ locale.city_name }}:* </span>
                  <input class="w-100" style="height: 2rem" v-model="this.worker_selected_city">
                </div>
              </div>
              <div class="d-flex adaptive-justify-content">
                <div class="mb-3 d-flex flex-column w-40">
                  <span class="w-100">{{ locale.country_name }}:* </span>
                  <input class="w-100" style="height: 2rem" v-model="this.worker_selected_country">
                </div>
                <div class="d-flex flex-column w-40">
                  <span class="w-100">{{ locale.address_line1 }}:* </span>
                  <input class="w-100" style="height: 2rem" v-model="this.worker_selected_al1">
                </div>
              </div>
              <div class="d-flex adaptive-justify-content adaptive-margin">
                <div class="d-flex flex-column w-100">
                  <span class="w-100">{{ locale.address_line2 }}: </span>
                  <input class="w-100" style="height: 2rem" v-model="this.worker_selected_al2">
                </div>
              </div>
            </div>
            <br>
            <hr>
            <i v-if="!pidn_valid">* {{ locale.personal_no }} {{locale.is_not_valid}}</i>
            <br>
            <i v-if="!email_valid">* {{ locale.email }} {{locale.is_not_valid}}</i>
            <br>
            <i v-if="!emp_num_valid">* {{ locale.employment_number }} {{locale.is_not_valid}}</i>
            <br>
            <i v-if="!login_valid">* {{ locale.login }} {{locale.is_not_unique}}</i>

            <div style="text-align: center">
              <n-button v-if="modal_type == 'add'"
                        type="primary"
                        class="btn btn-sm btn-primary"
                        :class="{disabled: !(checkRequiresOnAdd() && pidn_valid && emp_num_valid && login_valid && email_valid)}"
                        @click.native="addUser()"
              >
                <span >{{ locale.add_worker }}</span>
              </n-button>
              <n-button v-if="modal_type == 'update'"
                        type="primary"
                        class="btn btn-sm btn-primary"
                        :class="{disabled: !(checkRequiresOnEdit() && pidn_valid && emp_num_valid && login_valid && email_valid)}"
                        @click.native="updateUser()"
              >
                <span >{{ locale.update_worker }}</span>
              </n-button>

            </div>
          </div>
        </modal>
        <modal name="address-form"
               :adaptive="true" :resizable="true" :minHeight="500"
               @opened="modalOpened"
        >
          <template>
            <div style="margin: 1em; margin-top: 2em;">
              <div class="d-flex justify-content-between">
                <div class="mb-3 d-flex flex-column w-100">
                  <span>{{ locale.address }}</span>
                  <div id="geocoder"></div>
                </div>
              </div>

              <br>
              <div v-show="map_visible" id="map" style="max-height: 250px"></div>
            </div>
            <div class="text-center" type="primary" @click="onModalHide('address-form')">
              <n-button>Ok</n-button>
            </div>
          </template>
          <br>
        </modal>
        <modal name="calendar-form" :adaptive="true"
               height="auto" :scrollable="true" class="calendar-form">
          <div style="margin: 1em; margin-top: 3em;">
            <n-button
                @click.native="onModalHide('calendar-form')"
                class="remove text-end close-modal-btn"
                type="danger"
                size="sm"
                round
                icon
            >
              <i class="fa fa-times"></i>
            </n-button>
          <h3 style="margin-left:8px" v-if="this.w_id_for_opened_form!==-1"> {{
              this.users.find((e) => e.id === this.w_id_for_opened_form)['first_name'] + ' ' + this.users.find((e) => e.id === this.w_id_for_opened_form)['last_name']
            }} </h3>
          <YearCalendar
              :lang="lang"
              :show-year-selector="true"
              v-model="year"
              :activeDates.sync="activeDates"
              @toggleDate="toggleDate"
              prefixClass="your_customized_wrapper_class"
              :activeClass="activeClass"
          ></YearCalendar>
          </div>
        </modal>
        <modal name="timesheet-form" height="1000px"  width="1300px">
          <div style="margin: 1em; margin-top: 3em;">
            <n-button
                @click.native="onModalHide('timesheet-form')"
                class="remove text-end close-modal-btn"
                type="danger"
                size="sm"
                round
                icon
            >
              <i class="fa fa-times"></i>
            </n-button>
            <hot-table :key="counter" id="1234"  :beforeChange="beforeChange" :afterAutofill="afterAutofill" :beforePaste="beforePaste" :afterSelectionEnd="afterSelectionEnd" style=" display: flex; margin:auto" width="1108px" :data="data" :cell="cell" :rowHeaders="false" :colHeaders="false" :mergeCells="mergeCells" :rowHeights="rowHeights" :scrollable="false" :columnSummary="columnSummary"></hot-table>

<!--              :fillHandle = "false"-->
          </div>
        </modal>
        <!--        <div slot="footer" class="card-footer d-flex justify-content-end">-->
<!--          <n-pagination v-model="page" @click.native="changePage()" class="pagination-no-border" :total="this.users.length">-->
<!--          </n-pagination>-->
<!--        </div>-->
      </card>
    </div>
  </div>
</template>
<script>
import {Table, TableColumn, Select, Option, Checkbox} from "element-ui";
// import {Pagination as NPagination} from "src/components";
import mapboxgl from "mapbox-gl";
import printJS from 'print-js'
import MapboxGeocoder from "@mapbox/mapbox-gl-geocoder";
import YearCalendar from 'vue-material-year-calendar';
import  dayjs from 'dayjs';
import { HotTable } from '@handsontable/vue';
import { registerAllModules } from 'handsontable/registry';
import 'handsontable/dist/handsontable.full.css';
import Handsontable from 'handsontable/base';

const url = process.env.VUE_APP_API_BASE_URL;

registerAllModules();


export default {
  components: {
    // NPagination,
    YearCalendar:YearCalendar,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Checkbox.name]: Checkbox,
    HotTable,
  },
  data() {
    return {
      data: [
      ],
      mergeCells: [
      ],
      cell: [
      ],
      rowHeights(index) {
        if (index === 3) {
          return 100;
        }
        else {
          return 22;
        }
      },
      timeValidator (value, callback)  {
          function validateFloat(input) {
              const regex = /^\d{1,2}(\.\d{1,2})?$/;
              return input === "" || regex.test(input) && parseFloat(input) >= 0 && parseFloat(input) <= 24;
          }
          if (validateFloat(value) || value == null) {
              callback(true);
          } else {
              callback(false);
          }
      },
      counter: -1,
      columnSummary: [],
      daysInSelectedMonth: -1,
      searchedValue: '',
      lang:process.env.VUE_APP_LOCALE,
      activeClass: 'selected-date',
      year: new Date().getFullYear(),
      activeDates: [
      ],
      roles: [],
      ag: [],

      page: 1,
      pageSize: 10,

      map_visible: true,
      locale: '',

      access_token: process.env.VUE_APP_MAP_BOX_API_KEY,
      center: [18, 65],
      map: {},

      selected_mapbox_address: '',
      selected_latitude: '',
      selected_longitude: '',
      worker_address: '',

      w_id_for_opened_form:-1,
      selected_month: new Date().getMonth() + 1,

      worker_selected_address: '',
      worker_selected_country: '',
      worker_selected_region: '',
      worker_selected_city: '',
      worker_selected_pc: '',
      worker_selected_al1: '',
      worker_selected_al2: '',

      for_which: '',

      total: 0,
      users: [],
      usersPaged: [],
      usersFiltered: [],
      tableColumns: [
        {
          prop: "email",
          label: this.$getLocale().email,
          minWidth: 250,
        },
        {
          prop: "phone",
          label: this.$getLocale().phone,
          minWidth: 250,
        },
      ],
      worksheets_days : [],
      selected_role:'',
      selected_ag:'',
      new_user_emp_num: '',
      new_user_fn: '',
      new_user_ln: '',
      new_user_lg: '',
      new_user_psw: '',
      new_user_psw_cfm: '',
      new_user_pidn: '',
      upd_user_id: '',
      new_user_email: '',
      new_user_phone: '',
      modal_type: '',
      pidn_valid: false,
      emp_num_valid: false,
      login_valid: false,
      email_valid: false,
      user_ag: '',
      startRow : -1,
      endRow : -1,
      startCol : -1,
      endCol : -1,
    };
  },
  methods: {
    sortFName(a,b) {
        if (a.first_name.toUpperCase() <  b.first_name.toUpperCase()) return -1;
        if (a.first_name.toUpperCase() > b.first_name.toUpperCase()) return 1;
        return 0;
    },
    sortLName(a,b) {
        if (a.last_name.toUpperCase() <  b.last_name.toUpperCase()) return -1;
        if (a.last_name.toUpperCase() > b.last_name.toUpperCase()) return 1;
        return 0;
    },
    async beforeChange (changes) {
        const types = ['day_time','sick_time','travel_time','inconveniently_time','overtime'];
        if (changes[0][0] === 1 && changes[0][1] === 0 ) {
            this.selected_month = changes[0][3];
            changes[0][3] = `Select monts anyear: ${this.year}-${this.selected_month}-01`;
            await this.getWorksheets(this.w_id_for_opened_form, `${this.year}-${this.selected_month}`);
            this.getArrayOfDates(this.year, this.selected_month, this.w_id_for_opened_form);
            this.counter+=1;
        }
        else if (changes[0][0] > 3 && changes[0][1] > 1 && changes[0][0] < this.data.length - 1) {
            if ( changes[0][3] === "" || changes[0][3] === "0" || changes[0][3] === null) {
                changes[0][3] = "";
                await this.deleteWorksheetNote(`${this.year}-${this.selected_month}`, this.w_id_for_opened_form,  this.startRow - 3,this.endRow - 3 ,this.startCol - 2, this.endCol -2 );
                // for (let i = this.startCol;i<this.endCol;++i) {
                //     console.log(types[i - 2]);
                //      // await this.deleteWorksheetNote(`${this.year}-${this.selected_month}`, this.w_id_for_opened_form,i, this.startRow - 3, this.endRow - 3);
                // }
                // await this.deleteWorksheetNote(`${this.year}-${this.selected_month}`, this.w_id_for_opened_form,types[changes[0][1] - 2], changes[0][0] - 3);
            }
            else if (changes[0][3] >= 0 && changes[0][3] <= 24 && parseFloat(changes[0][3]) && parseFloat(changes[0][3]) > 0 && parseFloat(changes[0][3]) <= 24)  {
                await this.createWorksheetNote(`${this.year}-${this.selected_month}`, this.w_id_for_opened_form,types[changes[0][1] - 2], changes[0][3], changes[0][0] - 3);
            }
        }
    },

    async afterSelectionEnd(startRow, startColumn, endRow, endColumn) {
      this.startRow = startRow;
      this.endRow = endRow;
      this.startCol = startColumn;
      this.endCol = endColumn;
    },

    async beforePaste(data, coords) {
      let arr = [];
      for (let i = 0;i < data[0].length;++i) {
          for (let j = 0; j < data.length; ++j) {
            arr.push(data[j][i]);
          }
      }
      const day_start = coords[0]['startRow'] - 3;
      const day_end = coords[0]['startRow'] - 3 + data.length;
      const type_start = coords[0]['startCol'] - 2;
      const type_end = coords[0]['startCol'] - 2 + data[0].length;
      await this.copyAutofillWorksheets(this.w_id_for_opened_form,`${this.year}-${this.selected_month}`, arr,day_start, day_end - 1, type_start, type_end - 1);
    },

    async afterAutofill(selectionData, sourceRange, targetRange, direction) {
      let arr = [];
      for (let i = 0;i < selectionData[0].length;++i) {
          for (let j = 0; j < selectionData.length; ++j) {
              arr.push(selectionData[j][i]);
          }
      }
      await this.copyAutofillWorksheets(this.w_id_for_opened_form,`${this.year}-${this.selected_month}`, arr,targetRange['from']['row'] - 3, targetRange['to']['row'] - 3
      , targetRange['from']['col'] - 2, targetRange['to']['col'] - 2
      );
    },

    clearArrays() {
        this.data = [];
        this.mergeCells = [];
        this.columnSummary = [];
    },

    getArrayOfDates(year, month, w_id) {
      this.w_id_for_opened_form = w_id;
      const worker = this.users.find((e) => e.id === w_id);
      this.clearArrays();
      this.data.push(['Select Worker', '', '', '', '', '', '']);
      this.data.push([`Select monts anyear: ${this.year}-${this.selected_month}-01`, '', '', '', '', '', '']);
      this.data.push([`Sow slelcted nama ${worker.first_name + ' ' + worker.last_name}`, '', '', '', '' ,'',w_id]);
      this.data.push(['Datum', 'Veckodag', 'Dagens alla arbetade timmar', 'Sjuklön (immar / Karens(K)', 'Restid antal timmar', 'Varav obekvem timd OG-tillägg (17-07)', 'Övertigstillägg (Ränas automatiskt)']);
      this.daysInSelectedMonth = new Date(year, month, 0).getDate();
      for (let i = 1;i <= this.daysInSelectedMonth;++i) {
        let dayOfTheWeek = new Date(2023, month - 1, i).getDay();
        --dayOfTheWeek;
        if (dayOfTheWeek < 0) {
          dayOfTheWeek = 6;
        }
        const day = this.worksheets_days.filter((e) => e.day == i);
        let arr = [i.toString(), this.locale.Days_of_the_week[dayOfTheWeek], '', '' ,'', '', ''];
        if (day!==null) {
            if (day.find((e) => e.type === 'sick_time')) {
                arr[3] = day.find((e) => e.type === 'sick_time').time;
            }
            if (day.find((e) => e.type === 'day_time')) {
                arr[2] = day.find((e) => e.type === 'day_time').time;
            }
            if (day.find((e) => e.type === 'travel_time')) {
                arr[4] = day.find((e) => e.type === 'travel_time').time;
            }
            if (day.find((e) => e.type === 'inconveniently_time')) {
                arr[5] = day.find((e) => e.type === 'inconveniently_time').time;
            }
            if (day.find((e) => e.type === 'overtime')) {
                arr[6] = day.find((e) => e.type === 'overtime').time;
            }
        }
        this.data.push(arr);
      }
      this.data.push(['Summa' , '', '', '' ,'', '', '']);
      this.mergeCells.push(
          { row: 0, col: 0, rowspan: 1, colspan: 7 },
          { row: 1, col: 0, rowspan: 1, colspan: 7 },
          { row: 2, col: 0, rowspan: 1, colspan: 6 },
          { row : this.data.length - 1, col: 0, rowspan : 1, colspan: 2});
      // this.cell.push({row :  this.data.length - 1, col : 0, className:'red-text' })
      this.columnSummary.push({
            ranges: [[4, this.data.length - 2]],
            sourceColumn: 2,
            type: 'sum',
            destinationRow: this.data.length - 1,
            destinationColumn: 2,
            forceNumeric: true,
            className: 'text-black'
      },{
            ranges: [[4, this.data.length - 2]],
            sourceColumn: 3,
            type: 'sum',
            destinationRow: this.data.length - 1,
            destinationColumn: 3,
            forceNumeric: true,
      },{
            ranges: [[4, this.data.length - 2]],
            sourceColumn: 4,
            type: 'sum',
            destinationRow: this.data.length - 1,
            destinationColumn: 4,
            forceNumeric: true
      },{
            ranges: [[4, this.data.length - 2]],
            sourceColumn: 5,
            type: 'sum',
            destinationRow: this.data.length - 1,
            destinationColumn: 5,
            forceNumeric: true
      },{
            ranges: [[4, this.data.length - 2]],
            sourceColumn: 6,
            type: 'sum',
            destinationRow: this.data.length - 1,
            destinationColumn: 6,
            forceNumeric: true
      },)
      this.styleTable();
    },

    styleTable() {
        this.cell.push({row :  0, col : 0, className:'red-text', readOnly: true });
        this.cell.push({row :  1, col : 0, className:'black-text' , type: 'dropdown', source: [1,2,3,4,5,6,7,8,9,10,11,12]});
        this.cell.push({row :  2, col : 0, className:'blue-text' , readOnly: true });
        this.cell.push({row :  2, col : 6, className:'blue-text', readOnly: true  });
        this.cell.push({row :  3, col : 0, className:'black-text', readOnly: true  });
        this.cell.push({row :  3, col : 1, className:'black-text' , readOnly: true });
        this.cell.push({row :  3, col : 2, className:'black-text', readOnly: true  });
        this.cell.push({row :  3, col : 3, className:'red-text' , readOnly: true });
        this.cell.push({row :  3, col : 4, className:'green-text', readOnly: true  });
        this.cell.push({row :  3, col : 5, className:'blue-text', readOnly: true  });
        this.cell.push({row :  3, col : 6, className:'black-text', readOnly: true  });
        for (let i = 4;i < this.data.length; ++i) {
            this.cell.push({row: i, col : 0, className: 'black-text align-right', readOnly: true});
        }
        for (let i = 4;i < this.data.length - 1; ++i) {
            this.cell.push({row: i, col : 1, className: 'black-text align-left' , readOnly: true});
        }
        for (let i = 4;i <= this.data.length - 2; ++i) {
            this.cell.push({row: i, col : 2,validator: this.timeValidator, className: 'black-text align-right'});
        }
        for (let i = 4;i <= this.data.length - 2; ++i) {
            this.cell.push({row: i, col : 3,validator: this.timeValidator, className: 'red-text align-right'});
        }
        for (let i = 4;i <= this.data.length - 2; ++i) {
            this.cell.push({row: i, col : 4,validator: this.timeValidator, className: 'green-text align-right'});
        }
        for (let i = 4;i <= this.data.length - 2; ++i) {
            this.cell.push({row: i, col : 5,validator: this.timeValidator, className: 'blue-text align-right'});
        }
        for (let i = 4;i <= this.data.length - 2; ++i) {
            this.cell.push({row: i, col : 6,validator: this.timeValidator, className: 'black-text align-right'});
        }
        this.cell.push({row :  this.data.length - 1, col : 2, className:'black-text align-right' });
        this.cell.push({row :  this.data.length - 1, col : 3, className:'red-text align-right' });
        this.cell.push({row :  this.data.length - 1, col : 4, className:'green-text align-right' });
        this.cell.push({row :  this.data.length - 1, col : 5, className:'blue-text align-right' });
        this.cell.push({row :  this.data.length - 1, col : 6, className:'black-text align-right' });
        this.cell.push({row :  this.data.length - 1, col : 0, className:'black-text align-center' });
    },

    changePage() {
      // this.usersPaged = this.users.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
    },

    validateEmail() {
      let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      let duplicated = [];
      if (this.modal_type == 'add')
        duplicated = this.users.filter(elem => elem.email == this.new_user_email);
      if (this.modal_type == 'update')
        duplicated = this.users.filter(elem => elem.email == this.new_user_email && elem.id != this.upd_user_id);
      this.email_valid = (regex.test(this.new_user_email) && duplicated.length === 0);
    },

    validatePidn() {
        let regex = /^(\d{2}){0,1}(\d{2})(\d{2})(\d{2})([-|+]{0,1})?(\d{3})(\d{0,1})$/;
        let duplicated = [];
        if (this.modal_type == 'add')
          duplicated = this.users.filter(elem => elem.personal_id_no == this.new_user_pidn);
        if (this.modal_type == 'update')
          duplicated = this.users.filter(elem => elem.personal_id_no == this.new_user_pidn && elem.id != this.upd_user_id);
      this.pidn_valid = (this.new_user_pidn.match(regex) && duplicated.length === 0);
    },

    validateEmpNum() {
      let duplicated = [];
      if (this.modal_type == 'add')
      {
        duplicated = this.users.filter(elem => elem.employment_number == this.new_user_emp_num);
        this.emp_num_valid = (duplicated.length === 0 && this.new_user_emp_num && this.new_user_emp_num != '' && this.new_user_emp_num != null
            && this.new_user_emp_num.length === 3);
      }
      if (this.modal_type == 'update')
      {
        duplicated = this.users.filter(elem => elem.employment_number == this.new_user_emp_num && elem.id != this.upd_user_id);
        this.emp_num_valid = (duplicated.length === 0 && this.new_user_emp_num && this.new_user_emp_num != '' && this.new_user_emp_num != null
            && (this.new_user_emp_num.length === 3 || this.new_user_emp_num.toString().length === 3));
      }

    },

    validateLogin() {
      let duplicated = [];

      if (this.modal_type == 'add')
        duplicated = this.users.filter(elem => elem.login == this.new_user_lg);

      if (this.modal_type == 'update')
        duplicated = this.users.filter(elem => elem.login == this.new_user_lg && elem.id != this.upd_user_id);

      this.login_valid = duplicated.length === 0;
      },

    modalOpened(event) {
      this.createMap();
    },

    addressForm() {
      this.$modal.show('address-form');
    },

    checkRequiresOnAdd() {
      return (this.new_user_psw != '' && this.new_user_psw_cfm != '' && this.new_user_psw == this.new_user_psw_cfm)
      && (this.new_user_fn && this.new_user_ln && this.new_user_pidn && this.new_user_lg && this.new_user_email);
    },

    checkRequiresOnEdit() {
      return (this.new_user_fn && this.new_user_ln && this.new_user_pidn && this.new_user_lg && this.new_user_psw == this.new_user_psw_cfm && this.new_user_email);
    },

    onModalHide(name) {
      this.$modal.hide(name);
    },

    selectWorkerReport(worker) {
      if (this.for_which === 'reports')
      {
        window.location = '/components/working-hours?workers&swid=' + worker.id;
      }
    },

    printListWorkers() {
      let printJson = this.usersFiltered;
      let properties = ["employment_number", "first_name", "last_name", "address_line1", "address_line2", "postal_code", "city", "phone", "email"];
      printJson.forEach(worker => {
        Object.keys(worker).forEach(field => {
          if (!worker[field])
            worker[field] = '';
        })
      })
      printJS({
        printable: printJson,
        properties: properties,
        type: 'json',
        gridHeaderStyle: 'font-size: 12px; border: 1px solid black;',
        gridStyle: 'font-size: 10px; border: 1px solid black;'
      })
    },

    onPrintSingleWorker(event, w_id) {
      let worker = this.users.filter(elem => elem.id == w_id)[0];
      Object.keys(worker).forEach(elem => {
        if (!worker[elem])
          worker[elem] = '';
      });
      printJS({
        printable: [worker],
        properties: ["personal_id_no", "employment_number", "first_name", "last_name", "status", "login", "address_line1", "address_line2", "postal_code", "city", "phone", "email"],
        type: 'json',
        gridHeaderStyle: 'font-size: 12px; border: 1px solid black;',
        gridStyle: 'font-size: 10px; border: 1px solid black;'
      })
      event.stopPropagation();
    },

    searchWorker() {
      if (!this.searchedValue) {
        this.usersFiltered = structuredClone(this.users);
        return;
      }

      this.usersFiltered = structuredClone(this.users.filter(elem => {
        let searchby = elem.first_name + ' ' + elem.last_name + ' (' + elem.employment_number + ')' + elem.email + ' ' + elem.phone;
        return searchby.toLowerCase().includes(this.searchedValue.toLowerCase());
      }))
    },

    async changeStatus(id, status) {
      let data = {
        'id': id,
        'status': status,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(data)
      };
      await fetch(url + "/change-status-worker", requestOptions)
    },

    async onAddUser() {
      this.selected_role = 'Worker'
      this.new_user_emp_num = '',
      this.validateEmpNum();
      this.new_user_fn = '';
      this.new_user_ln = '';
      this.new_user_lg = '';
      this.validateLogin();
      this.new_user_psw = '';
      this.new_user_pidn = '';
      this.validatePidn();
      this.new_user_email = '';
      this.validateEmail();
      this.new_user_phone = '';
      this.new_user_psw_cfm = '',
      this.modal_type = 'add';
      this.selected_mapbox_address = '';
      this.selected_latitude = '';
      this.selected_longitude = '';
      this.worker_selected_al1 = '';
      this.worker_selected_al2 = '';
      this.worker_selected_country = '';
      this.worker_selected_city = '';
      this.worker_selected_pc = '';
      this.$modal.show('user-form');
    },

    async addUser() {
      if (this.worker_selected_al1 && this.worker_selected_pc)
      {
        this.worker_selected_pc = this.worker_selected_pc.replace(/\s/g, '');
        if (!this.selected_latitude && !this.selected_longitude) {
          this.selected_mapbox_address = this.worker_selected_al1 + ', ' + this.worker_selected_pc + ', ' + this.worker_selected_city + ', ' + this.worker_selected_country;
          let mb = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
              +  encodeURIComponent(this.selected_mapbox_address)
              + '.json?limit=4&proximity=ip&access_token=' + this.access_token;

          await fetch(mb)
              .then(async response => {
                const data = await response.json();
                if (!data.features.length)
                  return;

                this.worker_selected_country = data.features[0].context.find(elem => elem.id.includes('country')).text;
                this.worker_selected_city = data.features[0].context.find(elem => elem.id.includes('place')).text;
                this.worker_selected_pc = data.features[0].context.find(elem => elem.id.includes('postcode')).text;
                if (data.features[0].text)
                  this.worker_selected_al1 = data.features[0].text;
                if (data.features[0].address)
                  this.worker_selected_al1 += ' ' + data.features[0].address;
                this.selected_mapbox_address = data.features[0].place_name;
                this.selected_latitude = data.features[0].geometry.coordinates[0];
                this.selected_longitude = data.features[0].geometry.coordinates[1];
              });
        }
      }
      let user_data;
      if (this.user_ag == null) {
        user_data = {
          'employment_number': this.new_user_emp_num,
          'first_name': this.new_user_fn,
          'last_name': this.new_user_ln,
          'login': this.new_user_lg,
          'personal_id_no': this.new_user_pidn,
          'password': this.new_user_psw,
          'email': this.new_user_email,
          'phone': this.new_user_phone,
          'address_line1': this.worker_selected_al1,
          'address_line2': this.worker_selected_al2,
          'country': this.worker_selected_country,
          'city': this.worker_selected_city,
          'postal_code': this.worker_selected_pc,
          'full_address': this.worker_selected_al1 + ', ' + this.worker_selected_pc + ', ' + this.worker_selected_city + ', ' + this.worker_selected_country,
          'latitude': this.selected_latitude,
          'longitude': this.selected_longitude,
          'role':this.selected_role,
          'ag':this.selected_ag,
        };
      }
      else {
        user_data = {
          'employment_number': this.new_user_emp_num,
          'first_name': this.new_user_fn,
          'last_name': this.new_user_ln,
          'login': this.new_user_lg,
          'personal_id_no': this.new_user_pidn,
          'password': this.new_user_psw,
          'email': this.new_user_email,
          'phone': this.new_user_phone,
          'address_line1': this.worker_selected_al1,
          'address_line2': this.worker_selected_al2,
          'country': this.worker_selected_country,
          'city': this.worker_selected_city,
          'postal_code': this.worker_selected_pc,
          'full_address': this.worker_selected_al1 + ', ' + this.worker_selected_pc + ', ' + this.worker_selected_city + ', ' + this.worker_selected_country,
          'latitude': this.selected_latitude,
          'longitude': this.selected_longitude,
          'role':this.selected_role,
        };
      }
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(user_data)
      };
      await fetch(url + "/add-worker", requestOptions)
          .then(response => window.location.reload());
      this.$modal.hide('user-form');
    },

    async onEditUser(id) {
      this.upd_user_id = id;
      let updating_user = this.users.filter(elem => elem.id == id)[0];
      this.modal_type = 'update';
      this.selected_role = updating_user.role;
      this.selected_ag = updating_user.ag;
      this.new_user_emp_num = updating_user.employment_number;
      if (this.new_user_emp_num)
      {
        if (this.new_user_emp_num.toString().length === 1)
          this.new_user_emp_num = ('0' + this.new_user_emp_num).slice(-3);
        if (this.new_user_emp_num.toString().length === 2)
          this.new_user_emp_num = ('00' + this.new_user_emp_num).slice(-3);
      }
      this.validateEmpNum();
      this.new_user_fn = updating_user.first_name;
      this.new_user_ln = updating_user.last_name;
      this.new_user_lg = updating_user.login;
      this.validateLogin();
      this.new_user_psw = updating_user.password;
      this.new_user_psw_cfm = updating_user.password;
      this.new_user_pidn = updating_user.personal_id_no;
      this.validatePidn();
      this.new_user_email = updating_user.email;
      this.validateEmail();
      this.new_user_phone = updating_user.phone;

      this.worker_selected_al1 = updating_user.address_line1;
      this.worker_selected_al2 = updating_user.address_line2;
      this.worker_selected_country = updating_user.country;
      this.worker_selected_city = updating_user.city;
      this.worker_selected_pc = updating_user.postal_code;
      this.selected_mapbox_address = this.worker_selected_al1 + ', ' + this.worker_selected_pc + ', ' + this.worker_selected_city + ', ' + this.worker_selected_country;
      this.selected_latitude = updating_user.latitude;
      this.selected_longitude = updating_user.longitude;

      this.$modal.show('user-form');
    },

    async updateUser() {
      if (this.worker_selected_al1 && this.worker_selected_pc)
      {
        this.worker_selected_pc = this.worker_selected_pc.replace(/\s/g, '');
        this.selected_mapbox_address = this.worker_selected_al1 + ', ' + this.worker_selected_pc + ', ' + this.worker_selected_city + ', ' + this.worker_selected_country;
        let mb = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
            +  encodeURIComponent(this.selected_mapbox_address)
            + '.json?limit=4&proximity=ip&access_token=' + this.access_token;

        await fetch(mb)
            .then(async response => {
              const data = await response.json();
              if (!data.features.length) {
                this.selected_latitude = '';
                this.selected_longitude = '';
                return;
              }

              this.worker_selected_country = data.features[0].context.find(elem => elem.id.includes('country')).text;
              this.worker_selected_city = data.features[0].context.find(elem => elem.id.includes('place')).text;
              this.worker_selected_pc = data.features[0].context.find(elem => elem.id.includes('postcode')).text;
              if (data.features[0].text)
                this.worker_selected_al1 = data.features[0].text;
              if (data.features[0].address)
                this.worker_selected_al1 += ' ' + data.features[0].address;
              this.selected_mapbox_address = data.features[0].place_name;
              this.selected_latitude = data.features[0].geometry.coordinates[0];
              this.selected_longitude = data.features[0].geometry.coordinates[1];
            });
      }
      let user_data
      if (this.user_ag == null) {
        user_data = {
          'employment_number': this.new_user_emp_num,
          'role':this.selected_role,
          'first_name': this.new_user_fn,
          'last_name': this.new_user_ln,
          'login': this.new_user_lg,
          'personal_id_no': this.new_user_pidn,
          'password': this.new_user_psw,
          'id': this.upd_user_id,
          'email': this.new_user_email,
          'phone': this.new_user_phone,

          'address_line1': this.worker_selected_al1,
          'address_line2': this.worker_selected_al2,
          'country': this.worker_selected_country,
          'city': this.worker_selected_city,
          'postal_code': this.worker_selected_pc,

          'full_address': this.selected_mapbox_address,
          'latitude': this.selected_latitude,
          'longitude': this.selected_longitude,
          'ag':this.selected_ag,
        };
      }
      else {
        user_data = {
          'employment_number': this.new_user_emp_num,
          'role':this.selected_role,
          'first_name': this.new_user_fn,
          'last_name': this.new_user_ln,
          'login': this.new_user_lg,
          'personal_id_no': this.new_user_pidn,
          'password': this.new_user_psw,
          'id': this.upd_user_id,
          'email': this.new_user_email,
          'phone': this.new_user_phone,

          'address_line1': this.worker_selected_al1,
          'address_line2': this.worker_selected_al2,
          'country': this.worker_selected_country,
          'city': this.worker_selected_city,
          'postal_code': this.worker_selected_pc,

          'full_address': this.selected_mapbox_address,
          'latitude': this.selected_latitude,
          'longitude': this.selected_longitude,
        };
      }
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(user_data)
      };
      await fetch(url + "/update-worker", requestOptions)
          .then(response => window.location.reload());
      this.$modal.hide('user-form');
    },

    async onDeleteUser(id) {
      let sure = confirm("Are you sure?");
      if (!sure)
        return;
      let user_data = {
        'id': id,
      };
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify(user_data)
      };
      await fetch(url + "/delete-worker", requestOptions)
          .then(response => window.location.reload());
    },

    async onOpenCalendar(event, w_id) {
      event.stopPropagation();
      this.w_id_for_opened_form = w_id;
      await this.getWeekends(this.w_id_for_opened_form);
      this.$modal.show('calendar-form');
    },

    async onOpenTimesheet(event, w_id) {
      event.stopPropagation();
      await this.getWorksheets(w_id, `${this.year}-${this.selected_month}`);
      this.getArrayOfDates(this.year, this.selected_month, w_id);
      this.w_id_for_opened_form = w_id;
      this.$modal.show('timesheet-form');
    },

    async getWorkers() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      fetch(url + '/list-workers', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            data.forEach(elem => {
              if (this.for_which == 'reports' && elem.status == 0)
                return;

              if (elem.status === 1)
                elem.status = true;
              if (elem.status === 0)
                elem.status = false;

              if (elem.employment_number)
              {
                if (elem.employment_number.toString().length === 1)
                  elem.employment_number = ('0' + elem.employment_number).slice(-3);
                if (elem.employment_number.toString().length === 2)
                  elem.employment_number = ('00' + elem.employment_number).slice(-3);
              }
              this.users.push(elem);
            })
            this.changePage();
            this.usersFiltered = structuredClone(this.users);
            this.total = data.length;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    async createMap() {
      try {
        mapboxgl.accessToken = this.access_token;
        this.map = new mapboxgl.Map({
          container: 'map',
          style: "mapbox://styles/mapbox/streets-v11?optimize=true",
          center: this.center,
          zoom: 4,
        });

        let geocoder = new MapboxGeocoder({
          accessToken: this.access_token,
          mapboxgl: mapboxgl,
          marker: false,
        });
        document.getElementById('geocoder').appendChild(geocoder.onAdd(this.map));
        geocoder.setPlaceholder(this.locale.worker_address + '*');
        this.map.addControl(new mapboxgl.NavigationControl());
        this.selected_mapbox_address = this.worker_selected_al1 + ', ' + this.worker_selected_pc + ', ' + this.worker_selected_city + ', ' + this.worker_selected_country;

        geocoder.on("result", (e) => {
          this.worker_selected_country = e.result.context.find(elem => elem.id.includes('country')).text;
          this.worker_selected_city = e.result.context.find(elem => elem.id.includes('place')).text;
          this.worker_selected_pc = e.result.context.find(elem => elem.id.includes('postcode')).text;
          if (e.result.text)
            this.worker_selected_al1 = e.result.text;
          if (e.result.address)
            this.worker_selected_al1 += ' ' + e.result.address;
          this.selected_mapbox_address = e.result.place_name;
          this.selected_latitude = e.result.geometry.coordinates[0];
          this.selected_longitude = e.result.geometry.coordinates[1];
          const marker = new mapboxgl.Marker({
            draggable: true,
            color: "#D80739",
          })
              .setLngLat(e.result.center)
              .addTo(this.map);
          this.center = e.result.center;
          marker.on("dragend", (e) => {
            this.center = Object.values(e.target.getLngLat());
            var url = 'https://api.mapbox.com/geocoding/v5/mapbox.places/'
                + this.center[0] + ', ' + this.center[1]
                + '.json?access_token=' + this.access_token;
            return fetch(url)
                .then(async response => {
                  const data = await response.json();
                  marker.remove();
                  geocoder.query(data.features[0].place_name);
                });
          });
        });
        if (this.selected_mapbox_address) {
          geocoder.query(this.selected_mapbox_address);
        }
      } catch (err) {
        console.log("map error", err);
      }
    },

    async get_ag() {
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
      };
      await fetch(url + "/list-ag", requestOptions).then(async response => {
            const data = await response.json();
            this.ag = data[0];
          }
      )
    },

    async get_roles() {
      const requestOptions = {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
      };
      await fetch(url + "/list-roles", requestOptions).then(async response => {
            const data = await response.json();
            this.roles = data[0];
          }
      )
    },

    async getLoggedRole() {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({title: 'Vue POST Request Example'})
      };
      return await fetch(url + '/get-logged-role', requestOptions)
          .then(async response => {
            const data = await response.json();

            // check for error response
            if (!response.ok) {
              // get error message from body or default to response status
              const error = (data && data.message) || response.status;
              return Promise.reject(error);
            }

            this.logged_user_role = data[0].name;
            this.user_ag = data[0].ag;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error('There was an error!', error);
          });
    },

    toggleDate (dateInfo) {
      console.log(dateInfo.date);
      if (this.activeDates.find((e) => e.date===dateInfo.date)) {
        this.deleteWeekend(dateInfo.date);
      } else {
        this.createWeekend(dateInfo.date);
      }
      // this.createWeekend(dateInfo.date);
    },

    async getWeekends(w_id) {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({'provider_staff_id': w_id})
      };
      return await fetch(url + '/get-weekends', requestOptions)
          .then(async response => {
            let data = await response.json();
            data = data[0];
            data.map((obj, i) => obj['className'] = 'selected-date')
            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }
            this.activeDates = data;
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },

    async createWeekend(date, w_id) {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({'day_off' : date, 'provider_staff_id' : this.w_id_for_opened_form})
      };
      return await fetch(url + '/add-weekend', requestOptions)
          .then(async response => {
            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },

    async deleteWeekend(date, w_id) {
      // POST request using fetch with error handling
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
          , 'Accept': 'application/json'
        },
        body: JSON.stringify({'day_off' : date, 'provider_staff_id' : this.w_id_for_opened_form})
      };
      return await fetch(url + '/delete-weekend', requestOptions)
          .then(async response => {
            // check for error response
            if (!response.ok) {
              // get error message from body or default to response statusText
              const error = (data && data.message) || response.statusText;
              return Promise.reject(error);
            }
          })
          .catch(error => {
            this.errorMessage = error;
            console.error("There was an error!", error);
          });
    },
      async createWorksheetNote(date, w_id, type, time, day) {
          // POST request using fetch with error handling
          const requestOptions = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
                  , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
                  , 'Accept': 'application/json'
              },
              body: JSON.stringify({'month_year' : date, 'provider_staff_id' : this.w_id_for_opened_form
              , 'time' : time, 'type' : type, 'day' : day})
          };
          return await fetch(url + '/add-worksheet', requestOptions)
              .then(async response => {
                  // check for error response
                  if (!response.ok) {
                      // get error message from body or default to response statusText
                      const error = (data && data.message) || response.statusText;
                      return Promise.reject(error);
                  }
              })
              .catch(error => {
                  this.errorMessage = error;
                  console.error("There was an error!", error);
              });
      },
      async deleteWorksheetNote(date, w_id, day_start, day_end, type_start, type_end) {
          // POST request using fetch with error handling
          const requestOptions = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
                  , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
                  , 'Accept': 'application/json'
              },
              body: JSON.stringify({'month_year' : date, 'provider_staff_id' : this.w_id_for_opened_form
              ,'day_start' : day_start, 'day_end' : day_end, 'type_start' : type_start, 'type_end' : type_end})
          };
          return await fetch(url + '/delete-worksheet', requestOptions)
              .then(async response => {
                  // check for error response
                  if (!response.ok) {
                      // get error message from body or default to response statusText
                  }
              })
              .catch(error => {
                  this.errorMessage = error;
                  console.error("There was an error!", error);
              });
      },
      async getWorksheets(w_id, month_year) {
          // POST request using fetch with error handling
          const requestOptions = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
                  , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
                  , 'Accept': 'application/json'
              },
              body: JSON.stringify({'provider_staff_id': w_id, 'month_year' : month_year})
          };
          return await fetch(url + '/get-worksheets', requestOptions)
              .then(async response => {
                  let data = await response.json();
                  data = data[0];
                  this.worksheets_days = data;
                  // data.map((obj, i) => obj['className'] = 'selected-date')
                  // // check for error response
                  // if (!response.ok) {
                  //     // get error message from body or default to response statusText
                  //     const error = (data && data.message) || response.statusText;
                  //     return Promise.reject(error);
                  // }
                  // this.activeDates = data;
              })
              .catch(error => {
                  this.errorMessage = error;
                  console.error("There was an error!", error);
              });
      },

      async copyAutofillWorksheets(w_id, month_year, data, day_start, day_end, type_start, type_end) {
          console.log(data);
          const requestOptions = {
              method: 'POST',
              headers: {
                  'Content-Type': 'application/json'
                  , 'Authorization': 'Bearer ' + localStorage.getItem("vue-authenticate.vueauth_access_token")
                  , 'Accept': 'application/json'
              },
              body: JSON.stringify({'month_year' : month_year ,'data' : data, 'day_start' : day_start, 'day_end' : day_end, 'type_start' : type_start, 'type_end' : type_end, 'provider_staff_id' : w_id})
          };
          return await fetch(url + '/copy-autofill-worksheet', requestOptions)
              .then(async response => {
                  // check for error response
                  if (!response.ok) {
                      // get error message from body or default to response statusText
                      const error = (data && data.message) || response.statusText;
                      return Promise.reject(error);
                  }
              })
              .catch(error => {
                  this.errorMessage = error;
                  console.error("There was an error!", error);
              });
      }
  },

  created() {
    this.getWorkers();
    this.get_roles();
    this.get_ag();
    this.getLoggedRole();
  },
  watch:{
    $route (to, from){
      this.for_which = Object.keys(to['query'])[0];
      window.location.reload();
    }
  },
  mounted() {
    this.locale = this.$getLocale();
    let query = window.location.search;
    const which = new URLSearchParams(query);
    this.for_which =  which.toString().slice(0, -1);
  },
};
</script>
<style scoped>
.vm--container.scrollable::v-deep .vm--modal {
    height: auto !important;
    overflow:hidden!important;
}

@media (min-width: 900px) {
    .calendar-form::v-deep .vm--modal {
        left: 15%!important;
        width: 70%!important;
    }
}

.vm--container::v-deep .red-text {
  color: #ff273c;
  text-align: center;
  font-weight: bold;
  vertical-align: middle;
}

.vm--container::v-deep .align-left {
    text-align: left!important;
}
.vm--container::v-deep .align-center {
    text-align: center!important;
}
.vm--container::v-deep .align-right {
    text-align: right!important;
}

.vm--container::v-deep .green-text {
  color: #689358;
  text-align: center;
  font-weight: bold;
  vertical-align: middle;
}

.vm--container::v-deep .blue-text {
  color: #3d7ac1;
  text-align: center;
  font-weight: bold;
  vertical-align: middle;
}

.vm--container::v-deep .black-text {
  color: #010101;
  text-align: center;
  font-weight: bold;
  vertical-align: middle;
}

.vm--container::v-deep .hot-display-license-info {
  display: none!important;
}

.vm--container::v-deep .vm--modal {
  /*height: auto !important;*/
  overflow:hidden!important;
}


.close-modal-btn {
  position: absolute;
  top: 0;
  right: 1%;
}

.w-40 {
  width: 44.5%;
}

select {
  border-radius: 8px;
  background-color: white;
  height: 2rem;
}

input {
  border-radius: 8px;
  border: 1px solid grey;
  height: 2rem;
}

.adaptive-row {
  display: flex;
  flex-direction: row;
}

@media (max-width: 600px) {
  .adaptive-row {
    display: flex;
    flex-direction: column;
    /*justify-content: center!important;*/
    align-items: center;
  }
}

.adaptive-row-child-width {
  width: 45%;
  margin-bottom: 1rem;
}

@media (max-width: 600px) {
  .adaptive-row-child-width {
    width: 100%;
    margin-bottom: 1rem;
  }
}



.adaptive-worker-select-width {
  width: 95%;
}

@media (max-width: 600px) {
  .adaptive-worker-select-width {
    width: 100%;
  }
}

.adaptive-margin {
  margin-left: 1rem;
  margin-right: 1rem;
}

@media (max-width: 600px) {
  .adaptive-margin {
    margin-left: 0;
    margin-right: 0;
  }
}

.adaptive-justify-content {
  justify-content: space-around;
}

@media (max-width: 600px) {
  .adaptive-justify-content {
    justify-content: space-between;
  }
}
</style>

<style>
.show-map {
  background-image: url("../../../../../public/img/icons/map-show.svg");
}

.hide-map {
  background-image: url("../../../../../public/img/icons/map-hide.svg");
}

.over400 {
  display: inline;
}
.below400 {
  display: none;
}
@media screen and (max-width: 400px) {
  .over400 {
    display: none;
  }
  .below400 {
    display: inline;
  }
}

.el-table::v-deep td:first-child{
    z-index: 999;
    /*display: flex;*/
    /*flex-direction: row;*/
    /*flex-wrap: wrap;*/
}
/*.handsontable td.htInvalid {*/
/*    background-color: white!important;*/
/*}*/

.calendar {
  min-width: 262px!important;
}

.selected-date {
  background-color:#00aca9!important;
  color: white;
}
.vue-calendar__container .container__months {
  padding: 0!important;
}
</style>
<style>
.card-body .vm--container {
    z-index: 9999999;
}
</style>